import axios from 'axios';

export async function getFromAPI(givenUrl) {
    let result = await axios({
        method: "get",
        url: givenUrl,
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        // console.log(error);
        return error;
    })

    return result;
}

export async function saveFormViaAPI(givenUrl, formData) {
    let result = await axios({
        method: "put",
        url: givenUrl,
        data: formData
    })
    .then(function (response) {
        // console.log('saveForm success:');
        // console.log(response.data);
        return {success: true, data: response.data};
    }).catch(function (error) {
        if (error) {
            // console.log(error);
            // console.log("saveForm error:");
            // console.log(error);
            return {success: false, data: error};
        }
    })

    return result;
}

export function getFullUrl(url, userNumber) {
    if(userNumber === undefined || userNumber === ""){
        return url;
    }else{
        return url.concat('/').concat(userNumber);
    }
}

export function getFullUrlWithFilters(url, currentPage, columnsToFetch, filters) {
    url = url.concat('/').concat(`?page=${currentPage}&per_page=25&columns=${columnsToFetch}&column=id&order=desc`);
    if (filters !== '') {
        url = url.concat('&filter=').concat(filters);
    }
    // console.log(url);
    return url;
}

/** Builds an array to render the page footer with.
* Identical to TeilnehmerData.vue, could be exported to functionCollection.js
* Footer ever only shows 5 pages, and attempts to keep current page in the middle. */
export function buildPageFooter(currentPage, maxPageNumber) {
    let upperLimit = 1;
    let lowerLimit = 1;
    let newPages = new Array();

    switch (currentPage) {
        case 2: // case 2 and 1 are identical
        case 1:
            if (maxPageNumber <= 5) {
                upperLimit = maxPageNumber;
            } else {
                upperLimit = 5;
            }
            for(let i = 1; i <= upperLimit; i++) {
                newPages.push(i);
            }
            // footerPageNumbers.value = newPages;
            return newPages;
            // break;

        case maxPageNumber - 1: // also identical to case maxPageNumber
        case maxPageNumber:
            upperLimit = maxPageNumber;
            lowerLimit = maxPageNumber - 4;
            if (lowerLimit < 1) lowerLimit = 1;
            for(let i = lowerLimit; i <= upperLimit; i++) {
                newPages.push(i);
            }
            // footerPageNumbers.value = newPages;
            return newPages;
            // break;

       default:
            upperLimit = currentPage + 2;
            lowerLimit = currentPage - 2;
            for (let i = lowerLimit; i <= upperLimit; i++) {
                newPages.push(i);
            }
            // footerPageNumbers.value = newPages;
            return newPages;
            // break;
   }
}

// disables page button when needed (when it's the button of the current page,
// or the left and right buttons when we're at the start or end of the page list).
export function isButtonDisabled(origin, currentPage, maxPageNumber) {
    switch (origin) {
        case 'start':
            return (currentPage === 1);
        case 'end':
            return currentPage === maxPageNumber;
        default:
            return (origin === currentPage);
    }
}

// download file from given URL to file. Called by the download functions above.
// copied from DataTable.vue, cause oof. execCommand is deprecated, but I have no idea how any of this works.
export function download_file(fileURL) {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = ''
            if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                document.location = save.href;
                // window event not working here
            } else {
                if (!!window.MSInputMethodContext && !!document.documentMode) {
                    var element = document.createElement('a');
                    element.setAttribute('href', fileURL);
                    element.setAttribute('download', fileURL);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }
        }
        // for IE < 11
        else if (!!window.ActiveXObject && document.execCommand) {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileURL)
            _window.close();
        }
    }
